import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, Modal, Btn, Input, Select, Badge } from "@/components/erp/ui";
import { toast } from "sonner";
import { Repeat } from "lucide-react";

const EMPTY = { with_employee_id: "", date_a: "", date_b: "", reason: "" };

export const ShiftSwaps = ({ onChanged }) => {
  const [d, setD] = useState({ me: null, items: [] });
  const [emps, setEmps] = useState([]);
  const [open, setOpen] = useState(false);
  const [f, setF] = useState(EMPTY);
  const load = () => api.get("/shift-swaps").then(({ data }) => setD(data)).catch(() => {});
  useEffect(() => { load(); api.get("/leave/colleagues").then(({ data }) => setEmps(data)).catch(() => {}); }, []);
  const submit = async () => {
    try { await api.post("/shift-swaps", { ...f, date_b: f.date_b || f.date_a }); toast.success("Ajakan tukar terkirim"); setOpen(false); setF(EMPTY); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Gagal mengirim"); }
  };
  const respond = async (id, accept) => {
    try { await api.post(`/shift-swaps/${id}/respond`, { accept }); toast.success(accept ? "Tukar shift disetujui, jadwal diperbarui" : "Ditolak"); load(); onChanged(); }
    catch (e) { toast.error(e.response?.data?.detail || "Gagal"); }
  };
  const cancel = async (id) => { try { await api.delete(`/shift-swaps/${id}`); load(); } catch (e) { toast.error(e.response?.data?.detail || "Gagal"); } };
  return (
    <Card className="p-5 mt-5" data-testid="shift-swaps">
      <div className="flex items-center gap-2 mb-3">
        <span className="font-semibold text-sm">Tukar Shift</span>
        <span className="text-xs text-slate-500">berlaku otomatis bila kedua orang setuju</span>
        {d.quota && d.quota.limit > 0 && <span data-testid="swap-quota" className={`text-xs rounded-full px-2 py-0.5 ${d.quota.used >= d.quota.limit ? "bg-rose-100 text-rose-700" : "bg-slate-100 text-slate-600"}`}>Terpakai {d.quota.used}/{d.quota.limit} bulan ini</span>}
        {d.me && <Btn className="ml-auto" variant="ghost" data-testid="swap-new-btn" onClick={() => setOpen(true)}><Repeat className="w-4 h-4" /> Ajak Tukar</Btn>}
      </div>
      {d.items.length === 0 && <div className="text-xs text-slate-400">Belum ada pengajuan tukar shift.</div>}
      <div className="space-y-2">
        {d.items.map((s) => (
          <div key={s.id} className="flex flex-wrap items-center gap-2 text-sm border-t border-slate-100 pt-2" data-testid={`swap-${s.id}`}>
            <span><b>{s.a_name}</b> ⇄ <b>{s.b_name}</b></span>
            <span className="text-xs text-slate-500">{s.date_a === s.date_b ? `tukar shift ${s.date_a}` : `${s.b_name} masuk ${s.date_a}, ${s.a_name} masuk ${s.date_b}`}{s.reason ? ` · ${s.reason}` : ""}</span>
            <Badge>{{ PENDING: "Menunggu", ACCEPTED: "Disetujui", REJECTED: "Ditolak" }[s.status] || s.status}</Badge>
            <span className="ml-auto flex gap-2">
              {s.status === "PENDING" && d.me === s.b_id && <><Btn data-testid={`swap-accept-${s.id}`} onClick={() => respond(s.id, true)}>Setuju</Btn><Btn variant="ghost" data-testid={`swap-reject-${s.id}`} onClick={() => respond(s.id, false)}>Tolak</Btn></>}
              {s.status === "PENDING" && d.me === s.a_id && <Btn variant="ghost" data-testid={`swap-cancel-${s.id}`} onClick={() => cancel(s.id)}>Batalkan</Btn>}
            </span>
          </div>
        ))}
      </div>
      <Modal open={open} onClose={() => setOpen(false)} title="Ajak Tukar Shift" footer={<><Btn variant="ghost" onClick={() => setOpen(false)}>Batal</Btn><Btn data-testid="swap-submit" onClick={submit}>Kirim</Btn></>}>
        <div className="grid gap-3 text-sm">
          <label>Rekan<Select data-testid="swap-with" value={f.with_employee_id} onChange={(e) => setF({ ...f, with_employee_id: e.target.value })}><option value="">Pilih…</option>{emps.filter((e) => e.id !== d.me).map((e) => <option key={e.id} value={e.id}>{e.name}</option>)}</Select></label>
          <label>Tanggal shift saya yang ditukar<Input type="date" data-testid="swap-date-a" value={f.date_a} onChange={(e) => setF({ ...f, date_a: e.target.value })} /></label>
          <label>Saya gantikan rekan di tanggal (kosong = tukar jam di tanggal yang sama)<Input type="date" data-testid="swap-date-b" value={f.date_b} onChange={(e) => setF({ ...f, date_b: e.target.value })} /></label>
          <label>Alasan<Input data-testid="swap-reason" value={f.reason} onChange={(e) => setF({ ...f, reason: e.target.value })} /></label>
        </div>
      </Modal>
    </Card>
  );
};
